import Vue from 'vue';
import VueDraggable from 'vuedraggable';
import VueSlideBar from 'vue-slide-bar';
import VueThinModal from 'vue-thin-modal';
import vClickOutside from 'v-click-outside';
import VueClipboard from 'vue-clipboard2';
import VueUA from '@jarvisniu/vue-ua';

import './sentry';
import './filters';
import './i18n';
import './notifications';
import './validation';
import './progress-bar';
import 'vue-thin-modal/dist/vue-thin-modal.css';
import './form';

Vue.component('Draggable', VueDraggable);
Vue.component('VueSlideBar', VueSlideBar);
Vue.use(VueThinModal);
Vue.use(vClickOutside);
Vue.use(VueClipboard);
Vue.use(VueUA);
